var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-table',{attrs:{"id":"report-sales-datatable","options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }